import InstallOrderPictureModal from './install-order-picture-modal.vue'
export default InstallOrderPictureModal
